// extracted by mini-css-extract-plugin
module.exports = {"link":"BuyingSystemNotification_link__17AOt"};